export type AppStateState = 'ready' | 'refreshing' | 'loading';

export interface AppState {
  state: AppStateState;
}

export const appState: AppState = {
  state: 'loading',
};
